import script from "./TraningVR.vue?vue&type=script&setup=true&lang=js"
export * from "./TraningVR.vue?vue&type=script&setup=true&lang=js"

import "./TraningVR.vue?vue&type=style&index=0&id=4864b3be&lang=scss"

const __exports__ = script;

export default __exports__